import { render, staticRenderFns } from "./PrivacyBanner.vue?vue&type=template&id=e06b6098&lang=pug"
import script from "./PrivacyBanner.vue?vue&type=script&lang=js"
export * from "./PrivacyBanner.vue?vue&type=script&lang=js"
import style0 from "./PrivacyBanner.vue?vue&type=style&index=0&id=e06b6098&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e06b6098')) {
      api.createRecord('e06b6098', component.options)
    } else {
      api.reload('e06b6098', component.options)
    }
    module.hot.accept("./PrivacyBanner.vue?vue&type=template&id=e06b6098&lang=pug", function () {
      api.rerender('e06b6098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/privacy/PrivacyBanner.vue"
export default component.exports